import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { UserService } from '../../services/user.service';
import { EventTrackerService } from '../../services/event-tracker/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { WebUtils } from '../../utils/web.utils';
var VerifyNewAccountComponent = /** @class */ (function () {
    function VerifyNewAccountComponent(router, activatedRoute, translate, userService, eventTracker, placeholderService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.placeholderService = placeholderService;
        this.isVerifying = false;
    }
    VerifyNewAccountComponent.prototype.ngOnInit = function () {
        var _this = this;
        WebUtils.loadHubspotChatWidget();
        this.isVerifying = true;
        this.activatedRoute.queryParams.subscribe(function (res) {
            _this.token = res.token;
            _this.onVerifyEmail(res.token);
        });
    };
    VerifyNewAccountComponent.prototype.ngOnDestroy = function () {
        WebUtils.removeHubspotChatWidget();
    };
    VerifyNewAccountComponent.prototype.onVerifyEmail = function (token) {
        var _this = this;
        this.placeholderService.show('verifyEmailHolder');
        this.userService.verifyEmail(token).subscribe(function (res) {
            _this.verifySuccess = true;
            _this.isVerifying = false;
            _this.placeholderService.hide('verifyEmailHolder');
            // Just `trackUserVerifyAccount` for the first time
            if (res.message !== 'already_verified') {
                _this.eventTracker.trackUserVerifyAccount(res.data.user);
            }
            window.location.href = res.data.redirectUrl;
        }, function (err) {
            _this.verifySuccess = false;
            _this.isVerifying = false;
            _this.placeholderService.hide('verifyEmailHolder');
            _this.navigateToLoginWhenAlreadyVerified(err);
        });
    };
    Object.defineProperty(VerifyNewAccountComponent.prototype, "verifyMessage", {
        get: function () {
            if (this.isVerifying) {
                return null;
            }
            return this.verifySuccess ? this.translate.instant('sign_up.verify_success') : this.translate.instant('sign_up.verify_error');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerifyNewAccountComponent.prototype, "verifyButton", {
        get: function () {
            if (this.isVerifying) {
                return this.translate.instant('sign_up.verifying_btn');
            }
            return this.verifySuccess ? this.translate.instant('sign_up.verify_success_btn') : this.translate.instant('sign_up.verify_error_btn');
        },
        enumerable: true,
        configurable: true
    });
    VerifyNewAccountComponent.prototype.afterVerify = function () {
        if (this.verifySuccess) {
            return this.router.navigate(['login']);
        }
        else {
            this.onVerifyEmail(this.token);
        }
    };
    VerifyNewAccountComponent.prototype.navigateToLoginWhenAlreadyVerified = function (error) {
        if (error instanceof HttpErrorResponse) {
            if (error.status === 400) {
                var message = error.error && error.error.message;
                if (message === 'already_verified') {
                    this.router.navigateByUrl('/login');
                }
            }
        }
    };
    return VerifyNewAccountComponent;
}());
export { VerifyNewAccountComponent };



// WEBPACK FOOTER //
// ./src/app/auth/verify-new-account/verify-new-account.component.ts.pre-build-optimizer.js